/**
 * Main content header copy keyed by route pathname (CareLayout).
 * `lead` may be a string or a React node.
 */
export const CARE_MAIN_HEADER_BY_PATH = {
  "/": {
    title: "Overview",
    lead: "",
  },
  "/doctors": {
    title: "Doctor profiles",
    lead: "Read-only doctor profiles linked to UsersAuth. Filter by status, tier, and package setup in the table headers.",
  },
  "/patients": {
    title: "Patient profiles",
    lead: "Patient demographics and preferences. Search condition, location, phone, and linked user fields.",
  },
  "/pharmacy": {
    title: "Pharmacy profiles",
    lead: "Pharmacy stores and contact details. Search store name, address, and location.",
  },
  "/transactions": {
    title: "Transactions",
    lead: "Transaction history from the care API when the endpoint is available.",
  },
  "/qr-manage": {
    title: "QR manage",
    lead: "Generate business-specific APK download QR codes and review download counts per partner location.",
  },
  "/support-logs": {
    title: "Customer support logs",
    lead: "Support activity from the care API.",
  },
  "/staff-access": {
    title: "Staff access management",
    lead: "Private section  -  staff accounts and roles for this dashboard.",
  },
  "/profile": {
    title: "Your profile",
    lead: "How you appear when signed in to the care dashboard.",
  },
  "/unauthorized": {
    title: "Access restricted",
    lead: "Your account does not have permission to view this section.",
  },
};

export function getCareMainHeader(pathname) {
  return (
    CARE_MAIN_HEADER_BY_PATH[pathname] ?? {
      title: "Dashboard",
      lead: null,
    }
  );
}
